<template>
    <a-row :gutter="10" class="file-row">
        <a-col span="13">{{item.name}}</a-col>
        <a-col span="5">{{item.size | bytes}}</a-col>
        <a-col span="6">
            <a-progress :percent="percent" :status="status" style="width: 95%;"/>
        </a-col>
    </a-row>
</template>

<script>
    export default {
        name: "UploadItem",
        props: {
            item: Object,
            percent: Number,
            status: String,
        }
    }
</script>

<style lang="less" scoped>
    .file-row {
        font-size: 12px;
        line-height: 22px;
        overflow-x: hidden;
    }
</style>
